import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import { Form } from "react-bootstrap";
import { toggleArray } from "~/services/helpers";
import { DebounceInput } from 'react-debounce-input';

const AdminReportSummary = ({ match, event, ...props }) => {

    const [response, setResponse] = useState({});
    const [selected, setSelected] = useState([]);

    const defaultFilters = {
        name: '',
        location: '',
    };

    const [filter, setFilter] = useState(defaultFilters);

    const loadData = () => {
        adminHttp
            .get('/report/summary?' + new URLSearchParams(filter).toString())
            .then(res => {
                setResponse(res.data);
            });
    };

    useEffect(loadData, [filter, event]);

    const handleClearFilter = () => {
        setFilter(defaultFilters);
    };

    const handleFilter = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let filterData = { ...filter, [name]: value };

        setFilter(filterData);
    };

    const handleSelectedChange = (id) => {
        setSelected(toggleArray(selected, id));
    };

    const downloadUrl = adminHttp.defaults.baseURL + 'report/summary/download?' + new URLSearchParams(filter).toString();
    const downloadSelectedUrl = adminHttp.defaults.baseURL + 'report/summary/download?' + new URLSearchParams({
        ids: selected
    }).toString();

    return (

        <div className="admin-inventory">
            <div className="row">
                <div className="col-6">
                    <h2>Summary Report</h2>
                </div>
                <div className="col-6 text-right">
                    <a href={downloadUrl} target="_blank" className="text-primary">
                        Download (.csv)
                    </a>
                    {selected.length > 0 && (
                        <>
                            <span> | </span>
                            <a href={downloadSelectedUrl} target="_blank" className="text-primary">
                                Download selected: {selected.length} (.csv)
                            </a>
                        </>
                    )}
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <div className="card shadow-sm bg-white reports-filter">
                        <div className="row pt-2 pb-2">
                            <div className="col-2">
                                <label className="mt-2 ml-4 text-muted">FILTER</label>
                            </div>
                            <div className="col-3">
                                <label className="font-weight-500 small">Event Name</label>

                                <DebounceInput
                                    onChange={handleFilter}
                                    value={filter.name}
                                    name="name"
                                    className="form-control" />
                            </div>
                            <div className="col-3">
                                <label className="font-weight-500 small">Event Location</label>

                                <DebounceInput
                                    onChange={handleFilter}
                                    value={filter.location}
                                    name="location"
                                    className="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <table className="table">

                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Event Name</th>
                                        <th scope="col">Location</th>
                                        <th scope="col">Start</th>
                                        <th scope="col">End</th>
                                        <th scope="col">Accepted</th>
                                        <th scope="col">Declined</th>
                                        <th scope="col">Pending</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {response.data?.map(r => (
                                        <tr key={r.id}>
                                            <td scope="row">
                                                <Form.Check
                                                    onChange={e => handleSelectedChange(r.id)}
                                                    key={r.id}
                                                    inline
                                                    type="checkbox"
                                                    id={'upload-' + r.id}
                                                    value={r.id}
                                                    checked={selected.indexOf(r.id) >= 0}
                                                />
                                            </td>
                                            <td scope="col">{r?.name}</td>
                                            <td scope="col">{r.location}</td>
                                            <td scope="col"><Moment format="DD/MM/YYYY">{r.start}</Moment></td>
                                            <td scope="col"><Moment format="DD/MM/YYYY">{r.end}</Moment></td>
                                            <td scope="col">{r.accepted}</td>
                                            <td scope="col">{r.declined}</td>
                                            <td scope="col">{r.pending}</td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>

                            {response.per_page < response.total && (
                                <Pagination
                                    activePage={response.current_page}
                                    itemsCountPerPage={response.per_page}
                                    totalItemsCount={response.total}
                                    pageRangeDisplayed={5}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    onChange={loadData}
                                />
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
});

export default connect(mapStateToProps)(AdminReportSummary);
